import styled from 'styled-components';

const data = [
  {
    idx: 1,
    time: '14:00~15:20',
    title: '땅집고옥션 플랫폼 소개 및 실전 연습',
    content: [
      {
        title: '땅집봇 AI 검색',
        desc: '프롬프트 기반 경매 물건 탐색',
      },
      {
        title: '나만의 알고리즘',
        desc: '투자 성향별 성공 패턴 도출 & 자동 추천',
      },
      {
        title: '퀀트 분석',
        desc: '12가지 수학적·통계적 분석 서비스 제공',
      },
    ],
    content2: [
      {
        title: 'AI 실시간 시세 분석',
        desc: '주소 입력만으로 경·공매 및 실거래 사례 자동 분석',
      },
      {
        title: '성공 실패사례 분석',
        desc: '실제 사건으로 배우는 리스크와 기회',
      },
      {
        title: '실전 케이스 실습',
        desc: '시세분석, 낙찰가 예측, 퀀트 분석 적용',
      },
    ],
  },
  {
    idx: 2,
    time: '15:30~16:00',
    title: 'NPL(부실채권) 마스터 클래스',
    content: [
      {
        title: 'NPL 핵심 이해',
        desc: '구조・유형・수익 모델 심층 학습',
      },
      {
        title: '엔플랫폼 실전 활용',
        desc: '국내 최초 AI 기반 NPL 투자 플랫폼 체험',
      },
      {
        title: '실전 매물 분석',
        desc: '실제 NPL 물건 공개,\n가치 산정 및 리스크 관리 전략 제시',
      },
    ],
  },
  {
    idx: 3,
    time: '16:00~16:20',
    title: '심화 전략 & 네트워킹',
    content: [
      {
        title: '성공 투자자 인사이트',
        desc: '실전 노하우와 전략 공유',
      },
      {
        title: '네트워킹 & Q&A',
        desc: '참가자 교류 및 맞춤형 상담',
      },
    ],
  },
];

function SeminarProcedure() {
  return (
    <Container>
      {data.map((session) => (
        <SessionContainer key={session.idx}>
          <SessionNumberContainer>
            Session {session.idx}
            <span>{session.time}</span>
          </SessionNumberContainer>
          <Title>{session.title}</Title>
          {session.content2 ? (
            <CardWrapperCol>
              <CardWrapper>
                {session.content.map((item, index) => (
                  <Card key={index}>
                    <CardTitle>{item.title}</CardTitle>
                    <CardDesc>{item.desc}</CardDesc>
                  </Card>
                ))}
              </CardWrapper>
              <CardWrapper>
                {session.content2.map((item, index) => (
                  <Card key={index}>
                    <CardTitle>{item.title}</CardTitle>
                    <CardDesc>{item.desc}</CardDesc>
                  </Card>
                ))}
              </CardWrapper>
            </CardWrapperCol>
          ) : (
            <CardWrapper>
              {session.content.map((item, index) => (
                <Card key={index}>
                  <CardTitle>{item.title}</CardTitle>
                  <CardDesc>{item.desc}</CardDesc>
                </Card>
              ))}
            </CardWrapper>
          )}
        </SessionContainer>
      ))}
    </Container>
  );
}

export default SeminarProcedure;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
`;

const SessionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const SessionNumberContainer = styled.div`
  display: flex;
  padding: 16px 20px;
  align-items: flex-end;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  background: #000;

  color: #00f0ff;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;

  & > span {
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%;
  }
`;

const Title = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const CardWrapperCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Card = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: #f6f6f6;
`;

const CardTitle = styled.div`
  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const CardDesc = styled.div`
  color: #2f2e2e;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  white-space: pre-line;
`;
